/*
 * Stageクラス
 * 主にMouseMoveイベントを制御
 * 必要なプロパティは都度追加
 */
export default class UserAgent {
  private static _instance: UserAgent;

  /*
   * スマホ/タブレットはtrue
   * タッチイベントが取れる端末はtrue
   */
  private _isMobile: boolean;

  /*
   * iPhone/iPadなど
   */
  private _isIOS: boolean;

  /*
   * Mac
   */
  private _isMac: boolean;

  /*
   * IE
   * svgタグのtransformの値がカンマ区切りでなく半角スペースとなるため判別が必要
   */
  private _isIE: boolean;

  constructor() {
    const agent: string = navigator.userAgent;

    this._isMac = agent.indexOf('Mac') >= 0;
    const isIOS: boolean = agent.indexOf('iPhone') > -1 || agent.indexOf('iPod') > -1 || (agent.indexOf('ipad') > 0 || (agent.indexOf('macintosh') > -1 && 'ontouchend' in document));
    const isAndroid: boolean = agent.indexOf('Android') > -1;
    this._isIOS = isIOS;
    this._isMobile = isIOS || isAndroid;
    this._isIE = (agent.indexOf('MSIE') >= 0 || agent.indexOf('Trident') >= 0);
  }

  public static get isMobile(): boolean {
    return UserAgent.instance._isMobile;
  }

  public static get isIE(): boolean {
    return UserAgent.instance._isIE;
  }

  private static get instance(): UserAgent {
    if (!UserAgent._instance) {
      UserAgent._instance = new UserAgent();
    }

    return UserAgent._instance;
  }
}
